import { render, staticRenderFns } from "./model_management.vue?vue&type=template&id=29940857&scoped=true"
import script from "./model_management.vue?vue&type=script&lang=js"
export * from "./model_management.vue?vue&type=script&lang=js"
import style0 from "./model_management.vue?vue&type=style&index=0&id=29940857&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29940857",
  null
  
)

export default component.exports